// @mui
import { Box, BoxProps } from "@mui/material";
// hooks
import useResponsive from "../../hooks/useResponsive";
// config
import { useSettingsContext } from "src/components/settings/SettingsContext";
import { HEADER, NAV } from "../../config-global";

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const { themeLayout } = useSettingsContext();

  const isNavMini = themeLayout === "mini";
  const isDesktop = useResponsive("up", "lg");

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          px: 2,
          py: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
          }),
        }),
        ...sx,
        bgcolor: "background.dark",
      }}
      {...other}
    >
      <Box sx={{ bgcolor: "background.default", borderRadius: 2, py: 2, minHeight: "100vh" }}>
        {children}
      </Box>
    </Box>
  );
}
